import * as React from 'react'

import { FormWrapper } from './FormWrapper'
import { useGetSalesTeamListOnMount } from '@user/store/salesTeam/hooks'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

export const ContentBack = () => {
  const teamStatus = useGetSalesTeamListOnMount()

  return (
    <>
      {teamStatus === 'pending' && (
        <Box p={2} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      )}

      {teamStatus === 'fail' && <Alert>Failed to load widget settings.</Alert>}

      {teamStatus === 'success' && <FormWrapper />}
    </>
  )
}

ContentBack.displayName = 'UpcomingFollowUpsContentBack'
